/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".group-edit[_ngcontent-%COMP%]   .input-group-btn[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:0 0 10px}\n/*# sourceMappingURL=assessment-group-edit.component.css.map*/"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/admin/assessment-group-edit/assessment-group-edit.component.css.shim.ngstyle.js.pre-build-optimizer.js